import { createManager } from 'redux-injectors';

import reducer from './reducer';

import saga from './saga';

import { REDUCER_KEY } from './constants';

const CouponListManager = createManager({
  name: 'CouponListManager',
  key: REDUCER_KEY,
  reducer,
  saga,
});

export default CouponListManager;
